defineCustomVueElement('csb-subcollections', {
    name: 'Subcollections',
    template: `<div class="csb-subcollections">
        <div v-if="collectionDecoded?.template?.includes('brand-collection') || collectionDecoded.template == 'brand-home-collection'">
            <div class="page-width">
                <h4>Filter by model</h4><p>Enter your model here, then click to view compatible products:  <input type="text" v-model="search" placeholder="enter model here:" /></p>
            </div>
            <div class="odd-even" v-for="(groups) in groupSubcollections" style="padding-bottom: 2rem;margin-bottom: 2rem;">
                <div class="page-width row grid grid--1-col grid--2-col-tablet grid--3-col-desktop ">
                    <div class="grid__item" v-for="(col) in groups">
                        <div v-if="compatModels(col.name).length > 0">
                            <h4><a :href="col.url + '?filter.p.m.custom.chain_spec=' + encodeURI(standardChainSpec(col.name))">{{ col.name}}</a> <span :class="'collection-icon ' + collectionDecoded.handle"><span>{{ col.group_id }}</span></span><span :class="'subcollection-icon ' + collectionDecoded.handle"><span>{{ col.subgroup_id }}</span></span></h4>
                            <ul class="subcollection-list compact">
                                <li v-for="model in compatModels(col.name)"><a :href="col.url + '?filter.p.m.custom.chain_spec=' + encodeURI(standardChainSpec(col.name))">{{ model.name }}</a></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div class="page-width">
                <h4>Select from the models below:</h4>
                <ul class="subcollection-list compact">
                    <li v-for="model in compatModels(collection.name)"><a :href="model.url">{{ model.name }}</a></li>
                </ul>
            </div>
        </div>
        <div class="page-width" v-else>
            <div class="row grid grid--1-col grid--2-col-tablet grid--4-col-desktop">
                <div class="grid__item" v-for="(col) in subcollectionsDecoded">
                    <div class="#collection-card shadow-hover-2-3 @inner-caption" style="width: 100%; display: flex; flex-direction: column; border-radius: 15px; overflow: hidden;">
                        <div class="#collection-card-image"
                            style="width: 100%; height: 100%; padding-top: 100%; position: relative; overflow: hidden; border-radius: 15px;">
                            <a :href="col.url" :aria-label="col.name">
                                <div v-if="col.url != null"
                                    :style="'position: absolute; top: 0; left: 0; width: 100%; height: 100%; background: white url(' + col.image + ') no-repeat center center / contain; border: 7px solid white; border-radius: 15px;'">&nbsp;
                                </div>
                            </a>
                        </div>
                    </div>
                    <!-- Additional Space for Text Visibility Below Image -->
                    <div class="#collection-card-caption @position:outer-bottom-center"
                        style="text-align: center; background-color: transparent;">
                        <h4 class="#collection-card-title heading-font @text-bg"><a :href="col.url" class="button">{{ col.name }}</a></h4>
                        <ul class="subcollection-list" v-if="compatModels(col.name).length > 0">
                            <li v-for="model in compatModels(col.name)"><a :href="col.url">{{ model.name }}</a></li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>`,
    props: [ 'collection', 'subcollections' ],
    data() {
        return {
            collectionDecoded: { default: {} },
            subcollectionsDecoded: { default: [] },
            search: '',
            csbStore: useCsbStore(),
            currentGroup: null
        }
    },
    methods: {
        compatModels(name) {
            var output = this.csbStore.groups.filter(i => i.brand.name == name || i.group == name || i.sub_group == name).reduce((result, current) => { 
                var collection_uri = null;
                if (current.collection != null) {
                collection_uri = current.collection.uri
                }
                Array.prototype.push.apply(result, current.models.map(m => { return { name: m, url: collection_uri }; })); return result; }, [])
            if (this.search != '') {
                output = output.filter(m => m.name.toLowerCase().includes(this.search.toLowerCase()))
            }
            return output.sort((a, b) => {
                var aName = a.name.toLowerCase()
                var bName = b.name.toLowerCase()
                if (aName > bName) {
                return 1
                }
                if (aName < bName) {
                return -1
                }
                return 0
            })
        },
        standardChainSpec(name) {
            var output = this.csbStore.groups.find(i => i.brand.name == name || i.group == name || i.sub_group == name)
            return output.chain_spec
        }
    },
    computed: {
        brands() {
            if (this.csbStore.groups.length == 0) {
            return []
            }
            var output = this.csbStore.groups.reduce((result, current) => { result[current.brand.id] = current.brand; return result; }, [])
            return Object.values(output).sort((a, b) => {
            var aName = a.name.toLowerCase()
            var bName = b.name.toLowerCase()
            if (aName > bName) {
                return 1
            }
            if (aName < bName) {
                return -1
            }
            return 0
            })
        },
        models() {       
            if (this.brand == '') {
                return [];
            } else {
                var output = this.csbStore.groups.filter(i => i.brand.id == this.brand).reduce((result, current) => { 
                    var collection_uri = null;
                    if (current.collection != null) {
                        collection_uri = current.collection.uri
                    }
                    Array.prototype.push.apply(result, current.models.map(m => { return { name: m, uri: collection_uri, sub_group: current.name, group: current.brand.name + ' - ' + current.group, brand: current.brand.name, brand_id: current.brand.id }})); return result; }, [])
                if (output.length == 0) {
                    return [ { name: 'View All', uri: null, group: 'Universal' } ];
                }
                return Object.values(output).sort((a, b) => {
                    var aName = a.brand.toLowerCase() + a.name.toLowerCase()
                    var bName = b.brand.toLowerCase() + b.name.toLowerCase()
                    if (aName > bName) {
                        return 1
                    }
                    if (aName < bName) {
                        return -1
                    }
                    return 0
                })
            }
        },
        groupSubcollections() {
            var groups = this.subcollectionsDecoded.reduce((list, item) => {
                if (typeof(list[item.group_id]) == 'undefined') {
                    list[item.group_id] = [ item ]
                } else {
                    list[item.group_id].push(item)
                }
                return list
            }, [])
            return groups.map(group => {
                group = group.sort((a, b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0))
                console.log(group)
                return group
            })
        }
    },
    async mounted() {
        this.collectionDecoded = JSON.parse(this.collection)
        this.subcollectionsDecoded = JSON.parse(this.subcollections)
        this.subcollectionsDecoded = this.subcollectionsDecoded.map(c => {
            var name = c.name.toLowerCase().replace(this.collectionDecoded.name.toLowerCase() + ' - group ', '')
            c.group_id = name[0]
            c.subgroup_id = name[1].toUpperCase()
            return c
        })
        await this.csbStore.init()
    }
}, { plugins: [ piniaStore ] })